export { default } from './TeamChatReferenceBadge';
